export enum IProjectType {
  NewInstallation = 0,
  Renovation,
  Barge,
  Frame,
}
